import appClient from '../../common/services/AppClient';
import {
    ApplicationDefinitionConditionalDto,
    InputFieldSettingDto
} from '../../iota_applications/types/ApplicationDefinition';
import {
    AdditionalClassificationDto,
    AdditionalClassificationOptionDto,
    AdditionalClassificationRefreshPreviewDto,
    ApplicationDefinitionConditionalPreviewBindingResponse
} from '../../application_definition_conditional/types';
import security from '../../common/services/SecurityService';
import { Utils } from '../../common/services/Utils';
import { RcFile } from 'antd/lib/upload';
import { endpoints } from '../../../config';

export default class ApplicationDefinitionConditionalService {
    async updateData(
        projectId: string,
        appDefId: string,
        data: Pick<ApplicationDefinitionConditionalDto, 'conditions' | 'inputGroups'> & {
            additionalClassifications: AdditionalClassificationDto[];
            fieldSettings: InputFieldSettingDto[];
        }
    ) {
        const url = `${endpoints.manageUrl}projects/${projectId}/iota/applications/${appDefId}/application-definition-conditional`;

        return appClient.post<Omit<ApplicationDefinitionConditionalDto, 'type'>>(url, data);
    }

    async previewApplication(
        projectId: string,
        appDefId: string,
        data: Pick<ApplicationDefinitionConditionalDto, 'conditions' | 'inputGroups'> & { packageIds: string[] }
    ) {
        const url = `${endpoints.manageUrl}projects/${projectId}/iota/applications/${appDefId}/application-definition-conditional/preview-application`;

        return appClient.post<ApplicationDefinitionConditionalPreviewBindingResponse[]>(url, data);
    }

    async getAdditionalClassifications(projectId: string, appDefId: string) {
        const url = `${endpoints.manageUrl}projects/${projectId}/iota/applications/${appDefId}/application-definition-conditional/additional-classifications`;

        return appClient.get<AdditionalClassificationOptionDto[]>(url);
    }

    async getAdditionalClassificationPreview(projectId: string, appDefId: string, typeCode: string) {
        const url = `${endpoints.manageUrl}projects/${projectId}/iota/applications/${appDefId}/application-definition-conditional/additional-classifications/${encodeURIComponent(
            typeCode
        )}/preview`;

        return appClient.get<AdditionalClassificationDto>(url);
    }

    async getAdditionalClassificationRefreshPreview(
        projectId: string,
        appDefId: string,
        typeCode: string,
        current: AdditionalClassificationDto
    ) {
        const url = `${endpoints.manageUrl}projects/${projectId}/iota/applications/${appDefId}/application-definition-conditional/additional-classifications/${encodeURIComponent(
            typeCode
        )}/refresh-preview`;

        return appClient.post<AdditionalClassificationRefreshPreviewDto>(url, { current });
    }

    async exportAppConditions(id: string, projectId: string) {
        const mapForm = document.createElement('form');
        mapForm.setAttribute('id', 'iotaConditionsPostForm');
        mapForm.target = '_blank';
        mapForm.method = 'POST';
        const mapIotaIdInput = document.createElement('input');
        mapIotaIdInput.type = 'text';
        mapIotaIdInput.name = 'id';
        mapIotaIdInput.value = id;
        mapForm.appendChild(mapIotaIdInput);

        await security.invoke(token => {
            let t = '?access_token=' + encodeURIComponent(token);
            const url = endpoints.manageUrl + `projects/${projectId}/iota/applications/${id}/export-conditions${t}`;
            Utils.downloadFile(url, mapForm, 'iotaConditionsPostForm');
            return Promise.resolve();
        });
    }

    async commitAppBindings(id: string, projectId: string, file: RcFile) {
        var formData = new FormData();
        formData.append('file', file);
        const url = endpoints.manageUrl + `projects/${projectId}/iota/applications/${id}/commit-conditions`;
        return appClient.post(url, formData);
    }
}
